import { RequestService } from '../../../../common/services/RequestService';
import { API_AUTHORIZATION } from '../constants';

export const registrationRequest = payload => {
  return RequestService.post(API_AUTHORIZATION, payload);
};
